import React, { memo } from 'react'
import { Typography } from 'antd'
import { isEmpty, map } from 'lodash'
import PropTypes from 'prop-types'

import { StyledAiHighlightedText } from '../../../common/components/styled'
import { AI_HIGHLIGHT_STYLES } from '../../../common/constants'

import { dishIngredientPropType } from '../../prop-types'
import {
  StyledIngredientExplanationContainer,
  StyledIngredientExplanationParagraph,
} from '../styled'

const DishDetailsBlacklistedIngredients = ({ blacklistedIngredients }) => {
  if (isEmpty(blacklistedIngredients)) {
    return null
  }

  return (
    <>
      <Typography.Paragraph strong>
        Blacklisted ingredients based on Negative Synonyms
      </Typography.Paragraph>
      <StyledIngredientExplanationContainer>
        {map(
          blacklistedIngredients,
          ({
            ingredient,
            word,
            namePath,
            isSuggestedUsingParser,
            isSuggestedUsingMl,
          }) => (
            <StyledIngredientExplanationParagraph
              key={`blacklistedIngredient-${ingredient?.id}-${word}`}
            >
              {!isSuggestedUsingParser && isSuggestedUsingMl && 'ML'}
              {isSuggestedUsingParser && (
                <StyledAiHighlightedText
                  highlights={[AI_HIGHLIGHT_STYLES.negativeSynonym.value]}
                >
                  {word}
                </StyledAiHighlightedText>
              )}
              {' - '}
              {namePath}
            </StyledIngredientExplanationParagraph>
          ),
        )}
      </StyledIngredientExplanationContainer>
    </>
  )
}

DishDetailsBlacklistedIngredients.propTypes = {
  blacklistedIngredients: PropTypes.arrayOf(dishIngredientPropType).isRequired,
}

export default memo(DishDetailsBlacklistedIngredients)
